export default __webpack_public_path__ + "static/heroBg-35f8cf0bf946eb4b7d20d4dce265400f.png";